// Session Editor (2026-10-29, Phase 3 Stage 2, staging only) — shared helpers: styles, Europe/Amsterdam clock times,
// speed zones, period windows and the metric columns. See docs/statsports-phase3-design.md §7 and the mockup
// docs/statsports-phase3-editor-mockup.html. The API returns ids and numbers only; names are joined here from the
// existing players API.

export const SE_CSS = `
.se-root {
  --se-accent: #3b82f6; --se-handle: #3b82f6; --se-override: #a855f7; --se-group: #14b8a6; --se-warn: #f59e0b; --se-counted: #22c55e;
  --se-shade: rgba(59,130,246,0.10); --se-pill-bg: rgba(148,163,184,0.16); --se-est: #a78bfa;
  --se-z1: #334155; --se-z2: #2563eb; --se-z3: #16a34a; --se-z4: #eab308; --se-z5: #f97316; --se-z6: #dc2626;
  --se-nopos: #6b7280; --se-nodata: rgba(148,163,184,0.10);
  font-size: 13px;
}
[data-theme="day"] .se-root {
  --se-shade: rgba(59,130,246,0.12); --se-pill-bg: #eef1f5; --se-z1: #cbd5e1; --se-nodata: #f1f5f9; --se-nopos: #9ca3af;
}
.se-root .se-layout { display: grid; grid-template-columns: 300px minmax(0, 1fr); gap: 14px; align-items: start; }
.se-root .se-wide { grid-column: 1 / -1; min-width: 0; }
.se-root .se-table td.se-win { min-width: 250px; max-width: 420px; white-space: normal; }
.se-root .se-table .se-win-note { display: block; font-size: 11px; color: var(--text-muted); margin-top: 2px; line-height: 1.3; }
.se-root .se-panel { background: var(--bg-card); border: 1px solid var(--border); border-radius: 10px; padding: 12px 14px; margin-bottom: 12px; }
.se-root .se-panel h3 { font-size: 11px; font-weight: 700; letter-spacing: 0.06em; text-transform: uppercase; color: var(--text-muted); margin: 0 0 8px; }
.se-root .se-bar { display: flex; flex-wrap: wrap; gap: 8px; align-items: center; }
.se-root .se-grp { display: inline-flex; gap: 4px; align-items: center; }
.se-root .se-btn { padding: 5px 10px; border-radius: 7px; border: 1px solid var(--border-strong); background: var(--bg-card); color: var(--text-secondary); font: inherit; font-size: 12px; font-weight: 600; cursor: pointer; min-height: 28px; }
.se-root .se-btn:hover:not(:disabled) { color: var(--text-primary); border-color: var(--text-muted); }
.se-root .se-btn:disabled { opacity: 0.45; cursor: not-allowed; }
.se-root .se-btn--primary { background: var(--se-accent); border-color: var(--se-accent); color: #fff; }
.se-root .se-btn--primary:hover:not(:disabled) { color: #fff; filter: brightness(1.08); }
.se-root .se-btn--small { padding: 1px 6px; min-height: 20px; font-size: 11px; }
.se-root .se-btn--attention { box-shadow: 0 0 0 3px rgba(245,158,11,0.55); }
.se-root .se-hint--pending { background: rgba(16,185,129,0.14); }
.se-root .se-input, .se-root select.se-input { padding: 4px 7px; border-radius: 7px; border: 1px solid var(--border-strong); background: var(--bg-app); color: var(--text-primary); font: inherit; font-size: 12px; }
.se-root .se-time { width: 84px; font-family: 'IBM Plex Mono', ui-monospace, monospace; }
.se-root .se-time--active { outline: 2px solid var(--se-accent); }
.se-root .se-muted { color: var(--text-muted); font-size: 12px; }
.se-root .se-pill { font-size: 11px; padding: 1px 7px; border-radius: 10px; background: var(--se-pill-bg); color: var(--text-secondary); white-space: nowrap; }
.se-root .se-pill--warn { background: rgba(245,158,11,0.16); color: var(--se-warn); }
.se-root .se-pill--bad { background: rgba(239,68,68,0.14); color: #ef4444; }
.se-root .se-pill--est { background: rgba(167,139,250,0.16); color: var(--se-est); }
.se-root .se-list { list-style: none; margin: 0 0 12px; padding: 0; }
.se-root .se-list li { padding: 5px 8px; border-radius: 7px; cursor: pointer; display: flex; justify-content: space-between; gap: 6px; align-items: baseline; }
.se-root .se-list li:hover { background: var(--se-pill-bg); }
.se-root .se-list li.se-on { background: rgba(59,130,246,0.14); box-shadow: inset 2px 0 0 var(--se-accent); }
.se-root .se-list li.se-dim { opacity: 0.55; }
.se-root .se-list .se-child { padding-left: 22px; font-size: 12px; }
.se-root .se-banner { padding: 6px 10px; border-radius: 7px; background: var(--se-pill-bg); color: var(--text-secondary); font-size: 12px; }
.se-root .se-error { padding: 6px 10px; border-radius: 7px; background: rgba(239,68,68,0.12); color: #ef4444; font-size: 12px; }
.se-root .se-sub { border: 1px dashed var(--border-strong); border-radius: 8px; padding: 10px; margin-top: 8px; }
.se-root .se-canvaswrap { position: relative; width: 100%; }
.se-root .se-canvaswrap canvas { display: block; width: 100%; touch-action: none; cursor: crosshair; }
.se-root .se-tip { position: absolute; pointer-events: none; background: var(--bg-app); border: 1px solid var(--border-strong); border-radius: 6px; padding: 4px 7px; font-size: 11px; white-space: nowrap; z-index: 2; }
.se-root .se-legend { display: flex; flex-wrap: wrap; gap: 10px; font-size: 11px; color: var(--text-muted); margin-top: 6px; }
.se-root .se-legend i { display: inline-block; width: 10px; height: 10px; border-radius: 2px; margin-right: 4px; vertical-align: -1px; }
.se-root .se-tablewrap { overflow-x: auto; }
.se-root table.se-table { border-collapse: collapse; width: 100%; font-size: 12px; }
.se-root .se-table th { text-align: right; font-weight: 600; color: var(--text-muted); padding: 5px 6px; border-bottom: 1px solid var(--border-strong); white-space: nowrap; cursor: pointer; user-select: none; }
.se-root .se-table td { text-align: right; padding: 4px 6px; border-bottom: 1px solid var(--border); white-space: nowrap; font-variant-numeric: tabular-nums; vertical-align: top; }
.se-root .se-table th.l, .se-root .se-table td.l { text-align: left; }
.se-root .se-table tr.se-sel td { background: rgba(59,130,246,0.08); }
.se-root .se-table tr.se-out td { opacity: 0.5; }
.se-root .se-table tr.se-squad td { font-weight: 600; border-top: 1px solid var(--border-strong); }
.se-root .se-table .se-est { text-decoration: underline dotted var(--text-muted); text-underline-offset: 3px; }
.se-root .se-table .se-ours { display: block; font-size: 10px; color: var(--text-muted); }
.se-root .se-table .se-at { display: block; font-size: 10px; color: var(--text-muted); cursor: pointer; }
.se-root .se-hint { display: inline-flex; gap: 4px; align-items: center; background: rgba(245,158,11,0.12); color: var(--text-primary); border-radius: 6px; padding: 1px 6px; margin: 1px 4px 1px 0; font-size: 11px; white-space: normal; text-align: left; }
.se-root .se-hint button { border: none; background: none; cursor: pointer; font-size: 12px; padding: 0 2px; color: var(--text-secondary); }
.se-root .se-hint button:disabled { opacity: 0.4; cursor: not-allowed; }
.se-root .se-notes { list-style: none; margin: 8px 0 0; padding: 0; font-size: 12px; }
.se-root .se-notes li { display: flex; gap: 8px; align-items: baseline; padding: 2px 0; }
.se-root .se-keys td { padding: 2px 8px 2px 0; font-size: 12px; }
.se-root kbd { font: 11px ui-monospace, monospace; border: 1px solid var(--border-strong); border-bottom-width: 2px; border-radius: 4px; padding: 0 5px; }
@media (max-width: 1100px) { .se-root .se-layout { grid-template-columns: 1fr; } }
`;

// ── time (the UI shows and accepts Europe/Amsterdam; the API speaks UTC ISO) ─────────────────────────────────
export const TZ = 'Europe/Amsterdam';
const partsFmt = new Intl.DateTimeFormat('en-GB', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });
const parts = ms => Object.fromEntries(partsFmt.formatToParts(new Date(ms)).filter(p => p.type !== 'literal').map(p => [p.type, Number(p.value)]));
export const toMs = x => (x == null ? null : typeof x === 'number' ? x : Date.parse(x));
export const toIso = ms => (ms == null ? null : new Date(ms).toISOString());
export const snap = ms => Math.round(ms / 100) * 100;   // boundaries snap to 0.1 s, as on the server
// hh:mm:ss, or hh:mm:ss.d with tenths
export function clock(ms, tenths = false) {
  if (ms == null || !Number.isFinite(ms)) return '–';
  const p = parts(ms); const pad = n => String(n).padStart(2, '0');
  const base = `${pad(p.hour)}:${pad(p.minute)}:${pad(p.second)}`;
  return tenths ? `${base}.${Math.floor(((ms % 1000) + 1000) % 1000 / 100)}` : base;
}
// "hh:mm", "hh:mm:ss" or "hh:mm:ss.d" in Amsterdam time on the same local day as refMs → epoch ms (null if invalid)
export function parseClock(str, refMs) {
  const m = String(str || '').trim().match(/^(\d{1,2}):(\d{2})(?::(\d{2})(?:\.(\d))?)?$/);
  if (!m || refMs == null) return null;
  const [h, mi, s, d] = [Number(m[1]), Number(m[2]), Number(m[3] || 0), Number(m[4] || 0)];
  if (h > 23 || mi > 59 || s > 59) return null;
  const p = parts(refMs);
  const offset = Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second) - Math.floor(refMs / 1000) * 1000;
  return Date.UTC(p.year, p.month - 1, p.day, h, mi, s) - offset + d * 100;
}
export const mmss = sec => `${Math.floor(sec / 60)}:${String(Math.round(sec % 60)).padStart(2, '0')}`;
export const dateLabel = d => new Date(`${d}T12:00:00Z`).toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric', timeZone: 'UTC' });

// ── speed zones (absolute, as the engine: 1.5 / 3 / 4 / 5.5 / 7 / 11 m/s) ─────────────────────────────────────
export const ZONES = [0, 1.5, 3, 4, 5.5, 7, 11];
export const zoneOf = v => (v < 1.5 ? 1 : v < 3 ? 2 : v < 4 ? 3 : v < 5.5 ? 4 : v < 7 ? 5 : 6);
export const ZONE_LEGEND = [['Z1', '< 5.4'], ['Z2', '5.4–10.8'], ['Z3', '10.8–14.4'], ['Z4', '14.4–19.8'], ['Z5', '19.8–25.2'], ['Z6', '≥ 25.2 km/h']];

// ── names and labels (Sonra's rule: the filled-in labels joined with '-') ────────────────────────────────────
export const filledLabels = l => (l ? [l.primary, l.secondary, l.tertiary, l.free].filter(x => x != null && x !== '') : []);
export const composeName = l => filledLabels(l).join('-');
export const labelText = l => filledLabels(l).map(x => String(x).trim()).join(' · ');
export const isMatchLabels = l => !!(l && l.primary && l.primary.trim().toLowerCase() === 'match');

// ── windows (design §2): his own window, else his group's window, else the period ────────────────────────────
export function effectiveWindow(period, p) {
  const g = p.groupNo && period.groups && period.groups[p.groupNo];
  const base = g ? [toMs(g.start), toMs(g.end)] : [toMs(period.start), toMs(period.end)];
  return [p.start != null ? toMs(p.start) : base[0], p.end != null ? toMs(p.end) : base[1]];
}
export function subtract(intervals, cuts) {
  let cur = intervals.filter(([a, b]) => b > a);
  for (const [ca, cb] of cuts) {
    const next = [];
    for (const [a, b] of cur) { if (cb <= a || ca >= b) next.push([a, b]); else { if (ca > a) next.push([a, ca]); if (cb < b) next.push([cb, b]); } }
    cur = next;
  }
  return cur;
}
export function intervalsOf(period, p) {
  const cuts = (period.exclusions || []).filter(e => e.sessionPlayerId === p.sessionPlayerId && !e.removed).map(e => [toMs(e.from), toMs(e.to)]);
  return subtract([effectiveWindow(period, p)], cuts);
}
export const clone = x => JSON.parse(JSON.stringify(x));

// ── metric columns ─────────────────────────────────────────────────────────────────────────────────────────────
// One column = one metric with up to three sources, never mixed into one number:
//   calc     our calculation (own periods; imported periods with the "calc" switch), incl. average metabolic power
//   sonra    Sonra's KPI (imported periods: the default)
//   estimate our own estimate (Part B, 2026-10-29: HMLD, explosive distance, acc/dec ≥ 3 m/s²): row.estimates[key],
//            stored with source 'estimate'. Shown as a normal value (no "≈"); the note under the table says which columns
//            are estimates and holds the reliability notes.
// Own periods show calc, or the estimate where we do not calculate. Imported periods show Sonra first and ours next to it
// ("ours 39"), never one in place of the other. Squad rows are per source and never across sources.
export const COLUMNS = [
  { id: 'minutes', label: 'Min', digits: 1, title: 'minutes in his window' },
  { id: 'distance', label: 'Dist', unit: 'm', digits: 0 },
  { id: 'distPerMin', label: 'm/min', digits: 1 },
  { id: 'hsr', label: 'HSR', unit: 'm', digits: 0, title: 'high-speed running > 19.8 km/h (zones 5–6)' },
  { id: 'sprint', label: 'Sprint', unit: 'm', digits: 0, title: 'sprint distance > 25.2 km/h (zone 6)' },
  { id: 'maxSpeedKmh', label: 'Max', unit: 'km/h', digits: 1 },
  { id: 'averageMetabolicPower', label: 'AMP', unit: 'W/kg', digits: 2, title: 'average metabolic power (our calculation; 99.7 % of drills within 2 % of Sonra)' },
];
export const ZONE_COLUMNS = [1, 2, 3, 4, 5, 6].flatMap(z => [
  { id: `z${z}`, label: `Z${z}`, unit: 'm', digits: 0, zone: true },
  { id: `t${z}`, label: `T${z}`, unit: 'min', digits: 1, zone: true, scale: 1 / 60, title: `time in zone ${z}` },
]);
// Not part of our validated calculation: Sonra's KPI on imported periods, our estimate (`estimate` = its key) next to it
// or, on own periods, in its place.
export const ESTIMATE_COLUMNS = [
  { id: 'accelerationsGe3', label: 'Acc ≥3', digits: 0, sonraOnly: true, estimate: 'accelerationsGe3', count: true, title: 'accelerations ≥ 3 m/s² (zones 4–6)' },
  { id: 'decelerationsGe3', label: 'Dec ≥3', digits: 0, sonraOnly: true, estimate: 'decelerationsGe3', count: true, title: 'decelerations ≥ 3 m/s² (zones 4–6)' },
  { id: 'hmld', label: 'HMLD', unit: 'm', digits: 0, sonraOnly: true, estimate: 'hmld', title: 'high metabolic load distance (> 25.5 W/kg)' },
  { id: 'explosiveDistance', label: 'Expl', unit: 'm', digits: 0, sonraOnly: true, estimate: 'explosiveDistance', title: 'explosive distance = HMLD − HSR' },
];
const num = x => (x != null && Number.isFinite(Number(x)) ? Number(x) : null);
// → [{ value, source } | { hidden: reason }] in display order (first is the main value); [] = nothing to show
export function cellValues(col, row, { imported, view }) {
  const out = [];
  const scaled = v => (v == null ? null : col.scale ? v * col.scale : v);
  const est = num(row.estimates && col.estimate ? row.estimates[col.estimate] : null);
  const hidden = row.estimates && row.estimates.hidden && col.estimate ? row.estimates.hidden[col.estimate] : null;
  if (imported) {
    const main = view === 'calc' && !col.sonraOnly ? row.calc : row.sonra;
    const v = num(main ? main[col.id] : null);
    if (v != null) out.push({ value: scaled(v), source: view === 'calc' && !col.sonraOnly ? 'calc' : 'sonra' });
    if (est != null) out.push({ value: scaled(est), source: 'estimate' });
    else if (hidden) out.push({ hidden });
    return out;
  }
  const v = num(row.metrics ? row.metrics[col.id] : null);
  if (v != null) out.push({ value: scaled(v), source: 'calc' });
  else if (est != null) out.push({ value: scaled(est), source: 'estimate' });
  else if (hidden) out.push({ hidden });
  return out;
}
export const fmtNum = (v, digits) => (v == null || !Number.isFinite(v) ? '–' : v.toLocaleString('en-GB', { minimumFractionDigits: digits, maximumFractionDigits: digits }));

// ── Match days: excluded stretches (gaps build Stage A, 2026-11-02; the server's services/periods/gaps.js decides) ──
// span [a, b] minus his counted periods ([[a, b]], ms) → the stretches excluded for him, sorted
export function excludedStretches(span, counted) {
  const iv = (counted || []).filter(([a, b]) => b > a).slice().sort((x, y) => x[0] - y[0]);
  const out = []; let t = span[0];
  for (const [a, b] of iv) { if (a > t) out.push([t, Math.min(a, span[1])]); t = Math.max(t, b); if (t >= span[1]) break; }
  if (t < span[1]) out.push([t, span[1]]);
  return out.filter(([a, b]) => b > a);
}
// the movement hint ("movement in an excluded stretch") is dismissed at its own time only, like the server's isDismissed
// (and never by, nor dismissing, an "include" hint of the same player); every other hint as before
export const sameDismissal = (h, d, tolMs) => {
  const da = d.suggestion && d.suggestion.at;
  const timed = (h.values && h.values.rule === 'gap_movement') || (!['set_start', 'set_end', 'ignore'].includes(h.action) && da);
  if (timed) return !!(h.at && da) && Math.abs(toMs(h.at) - toMs(da)) <= tolMs;
  return !h.at || !da || Math.abs(toMs(h.at) - toMs(da)) <= tolMs;
};

// ── Entire Session - Live (decisions 2026-10-29; the server's services/periods/sessionLive.js is the authority) ───
// Used only to list, before Save, which other drills a shortened own window on Entire Session - Live will change.
const normName = n => String(n == null ? '' : n).trim().replace(/\s*-\s*/g, '-').toLowerCase();
export const isEsLive = p => !!p && (normName(p.name) === 'entire session-live'
  || (normName(p.labels && p.labels.primary) === 'entire session' && normName(p.labels && p.labels.secondary) === 'live'));
// players whose OWN window got shorter: [{ sessionPlayerId, end?, start? }]
export function shortenings(before, after) {
  const prev = new Map(before.players.map(p => [p.sessionPlayerId, p]));
  const out = [];
  for (const p of after.players) {
    const b = prev.get(p.sessionPlayerId);
    if (!p.included || !b || !b.included) continue;
    const [a0, a1] = effectiveWindow(after, p); const [b0, b1] = effectiveWindow(before, b);
    const cut = { sessionPlayerId: p.sessionPlayerId };
    if (p.end != null && a1 < b1) cut.end = a1;
    if (p.start != null && a0 > b0) cut.start = a0;
    if (cut.end != null || cut.start != null) out.push(cut);
  }
  return out;
}
// what the cuts do to one other period: [{ sessionPlayerId, action: 'end' | 'start' | 'out', at }]
export function carryOver(period, cuts) {
  const out = [];
  for (const cut of cuts) {
    const p = period.players.find(x => x.sessionPlayerId === cut.sessionPlayerId);
    if (!p || !p.included) continue;
    const [w0, w1] = effectiveWindow(period, p);
    let end = w1; let action = null; let at = null; let inside = true;
    if (cut.end != null && w1 > cut.end) { if (w0 >= cut.end) { inside = false; action = 'out'; at = cut.end; } else { end = cut.end; action = 'end'; at = cut.end; } }
    if (inside && cut.start != null && w0 < cut.start) { if (end <= cut.start) { action = 'out'; at = cut.start; } else { action = action || 'start'; at = at == null ? cut.start : at; } }
    if (action) out.push({ sessionPlayerId: cut.sessionPlayerId, action, at });
  }
  return out;
}

// Own and group windows never reach outside their period (decision 2026-10-29; the server's clipWindows is the
// authority and applies the same on Save). Mutates a draft (times in ms): a clipped edge on the period edge follows the
// period again, an empty own window takes him out, an empty or period-sized group window is removed.
export function clipDraft(d) {
  const ps = d.start; const pe = d.end;
  for (const k of Object.keys(d.groups || {})) {
    const g = d.groups[k]; const a = Math.max(g.start, ps); const b = Math.min(g.end, pe);
    if (!(b > a) || (a === ps && b === pe)) delete d.groups[k]; else d.groups[k] = { start: a, end: b };
  }
  for (const p of d.players) {
    if (p.start == null && p.end == null) continue;
    const g = p.groupNo && d.groups[p.groupNo];
    if (p.start != null && p.start < ps) p.start = g ? ps : null;
    if (p.end != null && p.end > pe) p.end = g ? pe : null;
    const [a, b] = effectiveWindow(d, p);
    if (!(b > a) || a >= pe || b <= ps) { p.included = false; p.start = null; p.end = null; }
    if (p.start == null && p.end == null) { p.windowSource = null; p.windowNote = null; }
  }
  return d;
}
